var Queensland = "Queensland";
var Tasmania = "Tasmania";
var Victoria = "Vittoria";
var AUStates = {
	"Australian Capital Territory": "Territorio della capitale australiana",
	"New South Wales": "Nuovo Galles del Sud",
	"Northern Territory": "Territorio del Nord",
	Queensland: Queensland,
	"South Australia": "Australia Meridionale",
	Tasmania: Tasmania,
	Victoria: Victoria,
	"Western Australia": "Australia occidentale"
};

export { Queensland, Tasmania, Victoria, AUStates as default };
